import React from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { Button, DialogOverlay, DialogOverlayActions, FlowGrid, Image, Paragraph } from '@fs/zion-ui'
import AttachFlowOnboardingImage from '../../../../assets/attachFlowOnboarding.png'

export default function NotTurnedOnDialog({ overlay, onTurnOn }) {
  const [t] = useTranslation()

  // "Not now" only dismisses; the seen preference already ensures the invite never shows again. We
  // leave the opt-in preference unset rather than writing an explicit opt-out, so the user stays in
  // the default (not-opted-in) state and can still turn it on later. See AttachFlowOnboardingDialog.
  const handleDismiss = () => {
    overlay.close()
  }

  const handleTurnOn = () => {
    onTurnOn?.()
    overlay.close()
  }

  return (
    <DialogOverlay
      {...overlay}
      size="md"
      onClose={handleDismiss}
      title={t('attachFlowOnboardingDialog.notTurnedOn.title', 'Updated look to the Names feature')}
      subtitle={t('attachFlowOnboardingDialog.notTurnedOn.subtitle', 'Turn it on to try it')}
      nonClosable
      footer={
        <DialogOverlayActions>
          <Button
            onClick={handleDismiss}
            linkName="attach-flow-onboarding-not-turned-on-not-now"
            data-testid="not-turned-on-not-now"
            color="gray"
          >
            {t('attachFlowOnboardingDialog.notTurnedOn.notNow', 'Not now')}
          </Button>
          <Button
            emphasis="high"
            onClick={handleTurnOn}
            linkName="attach-flow-onboarding-not-turned-on-turn-on"
            data-testid="not-turned-on-turn-on"
            color="gray"
          >
            {t('attachFlowOnboardingDialog.notTurnedOn.turnOn', 'Turn it on')}
          </Button>
        </DialogOverlayActions>
      }
    >
      <FlowGrid columnCount={1} gap="md" orientation="vertical">
        <Image src={AttachFlowOnboardingImage} height={270} aria-hidden="true" />
        <Paragraph>
          <Trans i18nKey="attachFlowOnboardingDialog.notTurnedOn.description">
            We&apos;ve updated the way you view, edit, and add names and details to a record. Turn it on to see this
            refreshed look on the <strong>Names</strong> tab.
          </Trans>
        </Paragraph>
        <Paragraph>
          {t('attachFlowOnboardingDialog.notTurnedOn.switchBack', 'You can switch back to the old view any time.')}
        </Paragraph>
      </FlowGrid>
    </DialogOverlay>
  )
}
